<template>
  <div v-if="this.model !== null && this.model.length >0">
    <div v-for="(item,index) in model">
        <div v-if="item.children !== null && item.children.length>0">
          <el-submenu :index="item.id">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>{{ item.label }}</span>
          </template>
          <NaviTree :model="item.children" :fatherMethod="goToProduct"></NaviTree>
          </el-submenu>
        </div>
        <div v-else>
          <el-menu-item :index="item.id" @click="goToProduct(item.id)">
            <i class="el-icon-s-claim"></i>
            <span slot="title">{{ item.label }}</span>
          </el-menu-item>
        </div>
    </div>
  </div>
  <div v-else>
    <el-row>
      <el-col :span="12">
        <div style="height: 300px;margin-top: 140px;" align="right">
          <svg-icon icon-class="oopsNothing" class-name="nothing"></svg-icon>
        </div>
      </el-col>
      <el-col :span="12">
        <div style="height: 300px;margin-top: 140px;  font-size: 30px; color: #00BCA1;" align="left">
          <div style="width: 100%">此分类暂时没有内容，看看其他的吧</div>
        </div>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  export default {
    name: "NaviTree",
    props: {
      model: {
        type: Array,
        default: null
      },
      fatherMethod: {
        type: Function,
        default: null
      }
    },
    data() {
      return {
        hasMenu: false
      }
    },
    created() {
    },
    methods: {
      goToProduct(itemId){
        if(this.fatherMethod){
          this.fatherMethod(itemId);
        }
      },
    }
  }
</script>

<style scoped>
  .nothing{
    font-size: 300px;
    fill: #00BCA1;
  }
</style>



// WEBPACK FOOTER //
// src/components/NaviTree.vue